export const T = {
  en_GB: { loading: "Loading meeting...", fallbackTitle: "Meeting" },
  nb_NO: { loading: "Laster møte...", fallbackTitle: "Møte" },
} as const;
